import React, {FC} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Card from "@irati/ui/src/Layout/Card"
import mainTheme from "@irati/ui/src/global/theme"
import {Label, Body} from "@irati/ui/src/Typography"

import {Quadrant} from "./quadrants"
import {SelectedQuadrantButton} from "./styled"

interface Props {
  quadrant: Quadrant | undefined,
  onBottomLeftClick: () => void,
  onTopLeftClick: () => void,
  onBottomRightClick: () => void,
  onTopRightClick: () => void
}

const Banner: FC<Props> = ({quadrant, onBottomLeftClick, onTopLeftClick, onBottomRightClick, onTopRightClick}) => {
  const getDescription = () => {
    if (quadrant) {
      if (quadrant === Quadrant.BottomLeftQuadrant) {
        return "admin.components.teamEngagement.banner.bottomLeftQuadrant.body"
      }
      if (quadrant === Quadrant.TopLeftQuadrant) {
        return "admin.components.teamEngagement.banner.topLeftQuadrant.body"
      }
      if (quadrant === Quadrant.BottomRightQuadrant) {
        return "admin.components.teamEngagement.banner.bottomRightQuadrant.body"
      }
      if (quadrant === Quadrant.TopRightQuadrant) {
        return "admin.components.teamEngagement.banner.topRightQuadrant.body"
      }
    }
    return "admin.components.teamEngagement.banner.defaultBody"
  }
  const description = getDescription()

  return (
    <Card bgColor={mainTheme.colors.tertiary.b_400} marginBottom={4}>
      <Label large display="block" color="white" marginBottom={2}>
        <FormattedMessage id="admin.components.teamEngagement.banner.label" />
      </Label>
      <SelectedQuadrantButton
        id="adminSection_quadrant_focusNow_button"
        selectedQuadrant={quadrant === Quadrant.BottomLeftQuadrant}
        onClick={onBottomLeftClick}
        inverted
        marginRight={2}>
        <FormattedMessage id="admin.components.teamEngagement.bottomLeftQuadrant.text" />
      </SelectedQuadrantButton>
      <SelectedQuadrantButton
        id="adminSection_quadrant_increaseActivePeople_button"
        selectedQuadrant={quadrant === Quadrant.TopLeftQuadrant}
        onClick={onTopLeftClick}
        inverted
        marginRight={2}>
        <FormattedMessage id="admin.components.teamEngagement.topLeftQuadrant.text" />
      </SelectedQuadrantButton>
      <SelectedQuadrantButton
        id="adminSection_quadrant_deepenUsage_button"
        selectedQuadrant={quadrant === Quadrant.BottomRightQuadrant}
        onClick={onBottomRightClick}
        inverted
        marginRight={2}>
        <FormattedMessage id="admin.components.teamEngagement.bottomRightQuadrant.text" />
      </SelectedQuadrantButton>
      <SelectedQuadrantButton
        id="adminSection_quadrant_learnFrom_button"
        selectedQuadrant={quadrant === Quadrant.TopRightQuadrant}
        onClick={onTopRightClick}
        inverted
        marginRight={2}>
        <FormattedMessage id="admin.components.teamEngagement.topRightQuadrant.text" />
      </SelectedQuadrantButton>
      <Body color="white" marginTop={2}>
        <FormattedMessage id={description} />
      </Body>
    </Card>
  )

}

export default Banner
